import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
        <div className="page-container" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            textAlign: 'center',
            padding: '40px 20px'
        }}>
            <h1 style={{ fontSize: '72px', color: '#007da5', margin: 0 }}>404</h1>
            <h2 style={{ fontSize: '24px', color: '#333', marginTop: '10px' }}>Faqja nuk u gjend</h2>
            <p style={{ color: '#666', marginTop: '20px', maxWidth: '500px' }}>
                Na vjen keq, por faqja që po kërkoni nuk ekziston ose mund të jetë zhvendosur.
            </p>
            <Link to="/" style={{
                marginTop: '30px',
                padding: '12px 24px',
                backgroundColor: '#ff8c00',
                color: '#fff',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: 'bold'
            }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#e67e00'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#ff8c00'}
            >
                Kthehu në Fillim
            </Link>
        </div>
    );
}
